/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import * as React from "react";
import { graphql } from "gatsby";
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";
import BlockText from "../components/BlockText";
import Layout from "../components/Layout";
import EventsGrid from "../components/EventsGrid";
import SEO from "../components/Seo";

const EventsPage = ({ data }) => {
  const block = {
    title: "Events",
    text: {
      html: "<p>Below you can find a grid of upcoming events and also a collection of past events.  Please select an event below to learn more.</p>",
    },
  };
  const events = data.allGraphCmsEvent.nodes;
  console.log("events", events);
  //filter events
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  today = yyyy + "-" + mm + "-" + dd;
  //futureevents
  const futureEvents = events.filter((item) => {
    if (item.regularEvent) {
      return item.endDate >= today;
    } else {
      return item.date >= today;
    }
  });
  //pastevents
  const pastEvents = events.filter((item) => {
    if (item.regularEvent) {
      return item.endDate < today;
    } else {
      return item.date < today;
    }
  });
  //sort past events to be most recent first
  pastEvents.sort((a, b) => {
    if (a.date > b.date) {
      return -1;
    }
    if (a.date < b.date) {
      return 1;
    }
  });

  return (
    <Layout>
      <SEO title="Events" />
      <Box>
        <StaticImage
          src="../images/tcuk-events.jpeg"
          alt="A woman in prayer"
          placeholder="blurred"
          layout="fullWidth"
          aspectRatio={1.97}
        />
      </Box>
      <BlockText data={block} pageTitle />
      <EventsGrid events={futureEvents} type="Upcoming" />
      <EventsGrid events={pastEvents} type="Past" />
    </Layout>
  );
};

export default EventsPage;

export const query = graphql`
  query EventsListQuery {
    allGraphCmsEvent(sort: { order: ASC, fields: date }) {
      nodes {
        title
        slug
        featuredImage {
          gatsbyImageData(layout: CONSTRAINED)
          alt
        }
        date
        endDate
        regularEvent
        regularEventDay
      }
    }
  }
`;
